import { Injectable } from '@angular/core';
import Swal from 'sweetalert2'

@Injectable({
    providedIn: 'root'
  })
export class NotificationService {

    private fireToast(icon: 'success' | 'error' | 'warning' | 'info', title?: string, text?: string): void {
        const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            showCloseButton: true,
            onOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
            }
        });

        Toast.fire({
            icon: icon,
            ...(title ? { title } : {}),
            ...(text ? { text } : {}),
        });
    }

    public success(title: string, text: string, isToast: boolean = false): void {
        if (!isToast) {
            Swal.fire({
                title: title,
                text: text,
                icon: 'success',
                timerProgressBar: true,
                confirmButtonText: 'Aceptar'
            })
        } else {
            this.fireToast('success', title, text);
        }
    }

    public error(title: string, text: string, isToast: boolean = false): void {
        if (!isToast) {
            Swal.fire({
                title: title,
                text: text,
                icon: 'error',
                timerProgressBar: true,
                confirmButtonText: 'Aceptar'
            })
        } else {
            this.fireToast('error', title, text);
        }
    }

    private errorToast(title?: string, text?: string): void {
        this.fireToast('error', title, text);
    }

    public errorApi(err: any, tituloDefault?: string): void {
        let title = tituloDefault ?? 'Error';
        let text: string | undefined;

        if (typeof err?.error === 'string') {
            text = err.error;
        }
        else if (err?.error) {
            title = err.error.titulo ?? tituloDefault ?? 'Error';
            text = err.error.mensaje;
        }

        this.errorToast(title, text);
    }


    public warning(title: string, text: string, isToast: boolean = false): void {
        if (!isToast) {
            Swal.fire({
                title: title,
                text: text,
                icon: 'warning',
                timerProgressBar: true,
                confirmButtonText: 'Aceptar'
            })
        } else {
            this.fireToast('warning', title, text);
        }
    }

    public info(title: string, text: string, isToast: boolean = false): void {
        if (!isToast) {
            Swal.fire({
                title: title,
                text: text,
                icon: 'info',
                timerProgressBar: true,
                confirmButtonText: 'Aceptar'
            })
        } else {
            this.fireToast('info', title, text);
        }
    }

    public async confirmation(title: string, text: string, confirmButtonText: string = 'Aceptar', cancelButtonText: string = 'Cancelar') {
        const res = await Swal.fire({
            title: title,
            text: text,
            icon: 'question',
            confirmButtonText: confirmButtonText,
            cancelButtonText: cancelButtonText,
            showCancelButton: true,
            showCloseButton: true
        })
        return res
    }

    public async warningAync(title: string, text: string) {
        const res = await Swal.fire({
            title: title,
            text: text,
            icon: 'warning',
            confirmButtonText: 'Aceptar',
            showCancelButton: false,
            showCloseButton: true
        })
        return res
    }

    public async sesionExpiredMsg(title: string, text: string) {
        const res = await Swal.fire({
            title: title,
            text: text,
            icon: 'warning',
            showCancelButton: false,
            backdrop: true,
            confirmButtonText: 'Aceptar',
            showConfirmButton: false,
            timerProgressBar: true,
            timer: 5000,
            allowEnterKey: false,
            focusConfirm: false
        })   
        return res
    }

}